import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppointmentTurn} from '@shared/models/appointment.model';
import {AppoTurnService} from '@shared/services/appo-turn.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'si-appo-arrival-turn-dialog',
  templateUrl: './appo-arrival-turn-dialog.component.html',
  styleUrls: ['./appo-arrival-turn-dialog.component.scss']
})
export class AppoArrivalTurnDialogComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  displayDialogArrivalTurn = false;
  model: AppointmentTurn;
  startDateNumber: number;

  constructor(
    private appoTurnService: AppoTurnService
  ) { }

  ngOnInit(): void {
    this.initInactivityDialog();
  }

  initInactivityDialog(): void {
    this.appoTurnService.initDialogTurn();
    this.subscriptions.push(
      this.appoTurnService.getDialogTurnObservable().subscribe(data => {
        this.model = data;
        this.startDateNumber = parseInt(data?.startDate);
        this.displayDialogArrivalTurn = !!data;
      })
    );
  }

  onChangeDisplayDialog(displayDialog: boolean): void {
    if (!displayDialog) {
      this.appoTurnService.closeDialogTurn();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
